<template>
  <v-navigation-drawer
    :model-value="mobile ? showBar : true"
    :rail="mobile ? false : rail"
    :permanent="mobile ? false : true"
    disable-route-watcher
    disable-resize-watcher
    :rail-width="railWidth"
    :location="mobile ? 'right' : 'left'"
  >
    <v-list density="compact" nav>
      <v-list-item v-if="!mobile">
        <svg-icon
          :src="projectLogo"
          :width="logoSize.width"
          :height="logoSize.height"
        />
        <template v-if="!rail" #append>
          <google-icon
            style="cursor: pointer"
            variant="rounded"
            :fill="false"
            icon="chevron_left"
            color="#60758D"
            :size="iconSize"
            @click.stop="rail = true"
          ></google-icon>
        </template>
      </v-list-item>
      <v-list-item
        v-for="(tool, index) in $store.getters.getPermissions"
        :key="index"
        :to="tool.route"
        nav
        class="list-item"
        :style="{ '--hover-bg': hoverColor }"
        color="transparent"
        base-color="transparent"
        active-class="list-item-active"
        v-ripple="{ class: 'ripple-effect' }"
        @click="mobile ? $emit('hide') : null"
        @click.stop="rail = false"
      >
        <template #prepend>
          <google-icon
            variant="rounded"
            :fill="false"
            :icon="tool.icon"
            color="#60758D"
            :size="iconSize"
          ></google-icon>
        </template>
        <template #title>
          <span class="list-item-text">{{ tool.title }}</span>
        </template>
      </v-list-item>
    </v-list>
    <template #append>
      <v-list density="compact" nav>
        <v-list-item
          to="/support"
          nav
          style="display: none"
          class="list-item"
          :style="{ '--hover-bg': hoverColor }"
          base-color="transparent"
          color="transparent"
          active-class="list-item-active"
          v-ripple="{ class: 'ripple-effect' }"
          @click="mobile ? $emit('hide') : null"
          @click.stop="rail = false"
        >
          <template #prepend>
            <google-icon
              class="list-items-icon"
              variant="rounded"
              :fill="false"
              icon="support"
              color="#60758D"
              :size="iconSize"
            ></google-icon>
          </template>
          <template #title>
            <span class="list-item-text">Suporte</span>
          </template>
        </v-list-item>
        <v-list-item
          to="/settings"
          nav
          style="display: none"
          class="list-item"
          :style="{ '--hover-bg': hoverColor }"
          color="transparent"
          active-class="list-item-active"
          v-ripple="{ class: 'ripple-effect' }"
          @click="mobile ? $emit('hide') : null"
          @click.stop="rail = false"
        >
          <template #prepend>
            <google-icon
              class="list-items-icon"
              variant="rounded"
              :fill="false"
              icon="settings"
              color="#60758D"
              :size="iconSize"
            ></google-icon>
          </template>
          <template #title>
            <span class="list-item-text">Configurações</span>
          </template>
        </v-list-item>
        <v-list-item
          v-show="false"
          to="/sc-maxx"
          nav
          color="transparent"
          active-class="list-item-active"
          v-ripple="{ class: 'ripple-effect' }"
        >
          <svg-icon
            :src="maxxLogo"
            :width="logoSize.width"
            :height="logoSize.height"
          />
        </v-list-item>
        <v-divider />
        <v-list-item
          class="logout-item"
          :style="`padding: ${toolsBar ? '0vw' : 'inherit'}`"
        >
          <template #prepend>
            <v-avatar
              v-if="mobile ? showBar : toolsBar"
              :size="avatarSize"
              color="#E8E9E9"
            >
              <span class="avatar-name">{{ avatarName }}</span>
            </v-avatar>
            <google-icon
              v-else
              variant="rounded"
              :fill="false"
              icon="logout"
              color="#60758D"
              :size="iconSize"
              style="cursor: pointer"
              @click="logout"
            ></google-icon>
          </template>
          <template v-if="mobile ? showBar : toolsBar" #title>
            <span class="user-name">
              {{ $store.getters.getUserData.full_name }}
            </span>
          </template>
          <template v-if="mobile ? showBar : toolsBar" #subtitle>
            <span class="user-role">{{ $store.getters.getUserRole }}</span>
          </template>
          <template v-if="mobile ? showBar : toolsBar" #append>
            <google-icon
              variant="rounded"
              :fill="false"
              icon="logout"
              color="#60758D"
              :size="logoutIconSize"
              style="cursor: pointer"
              @click="logout"
            ></google-icon>
          </template>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: "NavigationDrawer",
  props: {
    mobile: { type: Boolean, default: false },
    show: { type: Boolean, default: false }
  },
  data: () => ({
    rail: true,
    showBar: false,
    toolsBar: false
  }),
  methods: {
    async logout() {
      this.$router.push("/");
      await this.$store.dispatch("logoutSession");
    }
  },
  computed: {
    logoSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          if (this.toolsBar) {
            return { width: "20vh", height: "10vh" };
          } else {
            return { width: "1.5vh", height: "2vh" };
          }
        case this.$store.getters.isMobileLandscape:
          if (this.toolsBar) {
            return { width: "15vw", height: "8vw" };
          } else {
            return { width: "1.5vw", height: "2vw" };
          }
        case this.$store.getters.isTabletPortrait:
          if (this.toolsBar) {
            return { width: "12vh", height: "8vh" };
          } else {
            return { width: "2.5vh", height: "2.5vh" };
          }
        case this.$store.getters.isTabletLandscape:
          if (this.toolsBar) {
            return { width: "15vw", height: "8vw" };
          } else {
            return { width: "2.4vw", height: "2.4vw" };
          }
        default:
          if (this.toolsBar) {
            return { width: "10vw", height: "5vw" };
          } else {
            return { width: "1.5vw", height: "2vw" };
          }
      }
    },
    iconSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return "4vh";
        case this.$store.getters.isMobileLandscape:
          return "3vw";
        case this.$store.getters.isTabletPortrait:
          return "3vh";
        case this.$store.getters.isTabletLandscape:
          return "2.5vw";
        default:
          return "1.5vw";
      }
    },
    logoutIconSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return "3vh";
        case this.$store.getters.isMobileLandscape:
          return this.toolsBar ? "3vw" : "2vw";
        case this.$store.getters.isTabletPortrait:
          return this.toolsBar ? "2vh" : "3vh";
        case this.$store.getters.isTabletLandscape:
          return this.toolsBar ? "1.5vw" : "2vw";
        default:
          return "1.5vw";
      }
    },
    avatarSize() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return "6vh";
        case this.$store.getters.isMobileLandscape:
          return "5vw";
        case this.$store.getters.isTabletPortrait:
          return "3.5vh";
        case this.$store.getters.isTabletLandscape:
          return "3.5vw";
        default:
          return "2vw";
      }
    },
    railWidth() {
      switch (true) {
        case this.$store.getters.isMobilePortrait:
          return 56;
        case this.$store.getters.isMobileLandscape:
          return 56;
        case this.$store.getters.isTabletPortrait:
          return 65;
        case this.$store.getters.isTabletLandscape:
          return 60;
        default:
          return 56;
      }
    },
    avatarName() {
      const full_name = this.$store.getters.getUserData.full_name;
      const first_letter = full_name.split(" ")[0].charAt(0).toUpperCase();
      const second_letter = full_name.split(" ")[1].charAt(0).toUpperCase();

      return `${first_letter}${second_letter}`;
    },
    isFTX4() {
      return this.$store.getters.isFTX4;
    },
    projectLogo() {
      if (this.isFTX4) {
        if (this.toolsBar) {
          return require("@/assets/icons/farmacias_tx4.svg");
        } else {
          return require("@/assets/icons/farmacias_tx4_logo.svg");
        }
      } else {
        if (this.toolsBar) {
          return require("@/assets/icons/xmartshelf_logo_padrao.svg");
        } else {
          return require("@/assets/icons/xmartshelf.svg");
        }
      }
    },
    maxxLogo() {
      if (this.toolsBar) {
        return require("@/assets/icons/sc_maxx.svg");
      } else {
        return require("@/assets/icons/sc_maxx_logo.svg");
      }
    },
    colors() {
      return this.$vuetify.theme.global.current.colors;
    },
    hoverColor() {
      return this.colors.selectHover;
    }
  },
  watch: {
    show(value) {
      this.showBar = value;
    },
    rail(value) {
      if (!value) {
        this.toolsBar = true;
      } else {
        this.toolsBar = false;
      }
    }
  }
};
</script>
<style scoped>
/* CSS para versão Desktop */
@media (min-width: 1200px) and (orientation: landscape) {
  .list-item {
    overflow: hidden;
    text-align: left;
    padding: 0.5vw;
    border-radius: 2vw;
  }
  .list-item-active {
    text-align: left;
    padding: 0.5vw;
    border-radius: 2vw;
    border: 0.1vw solid #e8e9e9;
    overflow: hidden;
  }
  .list-item-text {
    font-weight: 700;
  }
  .list-item-text {
    margin-left: 1vw;
    text-align: left;
    font-size: 1vw !important;
    font-weight: 500;
    line-height: 1vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .logout-item {
    margin: 1vw 0vw 0vw 0.2vw !important;
    text-align: left;
  }
  .user-name {
    font-size: 0.8vw !important;
    font-weight: 600;
    line-height: 1vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .user-role {
    font-size: 0.8vw !important;
    font-weight: 400;
    line-height: 1vw;
    letter-spacing: 0vw;
    color: #60758d;
  }
  .avatar-name {
    font-size: 0.8vw !important;
    font-weight: 600;
    line-height: 1vw;
    letter-spacing: 0vw;
    color: #314050;
  }
}

/* CSS para versão Tablet na horizontal */
@media (max-width: 1200px) and (min-height: 600px) and (orientation: landscape) {
  .list-item {
    text-align: left;
    padding: 0.5vw;
    border-radius: 4vw;
    overflow: hidden;
  }
  .list-item-active {
    text-align: left;
    padding: 0.5vw;
    border-radius: 2vw;
    border: 0.1vw solid #e8e9e9;
    overflow: hidden;
  }
  .list-item-text {
    font-weight: 700;
  }
  .list-item-text {
    margin: 0vw 1vw 0vw 2vw;
    text-align: left;
    font-size: 1.5vw !important;
    font-weight: 500;
    line-height: 1.5vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .logout-item {
    margin: 1vw 1vw 1vw 0vw !important;
    text-align: left;
  }
  .user-name {
    font-size: 1.2vw !important;
    font-weight: 600;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #314050;
    margin-left: 0.5vw;
  }
  .user-role {
    font-size: 1.2vw !important;
    font-weight: 400;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #60758d;
    margin-left: 0.5vw;
  }
  .avatar-name {
    font-size: 1.2vw !important;
    font-weight: 600;
    line-height: 1.2vw;
    letter-spacing: 0vw;
    color: #314050;
  }
}

/* CSS para versão Tablet na vertical */
@media (min-width: 600px) and (orientation: portrait) {
  .list-item {
    text-align: left;
    padding: 0.5vh;
    border-radius: 4vh;
    overflow: hidden;
  }
  .list-item-active {
    text-align: left;
    padding: 0.5vh;
    border-radius: 2vh;
    border: 0.1vh solid #e8e9e9;
    overflow: hidden;
  }
  .list-item-text {
    font-weight: 700;
  }
  .list-item-text {
    margin: 0vh 0vh 0vh 1.5vh;
    text-align: left;
    font-size: 1.5vh !important;
    font-weight: 500;
    line-height: 1.5vh;
    letter-spacing: 0vh;
    color: #314050;
  }
  .logout-item {
    margin: 1vh 1vh 1vh 0vh !important;
    text-align: left;
  }
  .user-name {
    font-size: 1.5vh !important;
    font-weight: 600;
    line-height: 1.5vh;
    letter-spacing: 0vh;
    color: #314050;
  }
  .user-role {
    font-size: 1.5vh !important;
    font-weight: 400;
    line-height: 1.5vh;
    letter-spacing: 0vh;
    color: #60758d;
  }
  .avatar-name {
    font-size: 1.5vh !important;
    font-weight: 600;
    line-height: 1.5vh;
    letter-spacing: 0vh;
    color: #314050;
  }
}

/* CSS para versão Mobile na horizontal */
@media (max-width: 1024px) and (max-height: 600px) and (orientation: landscape) {
  .list-item {
    text-align: left;
    padding: 1.2vw;
    border-radius: 4vw;
    overflow: hidden;
  }
  .list-item-active {
    text-align: left;
    padding: 1.2vw;
    border-radius: 4vw;
    border: 0.1vw solid #e8e9e9;
    overflow: hidden;
  }
  .list-item-text {
    font-weight: 700;
  }
  .list-item-text {
    margin: 0vw 1vw 0vw 3vw;
    text-align: left;
    font-size: 2vw !important;
    font-weight: 500;
    line-height: 2vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .logout-item {
    margin: 1vw 1vw 1vw 0vw !important;
    text-align: left;
  }
  .user-name {
    font-size: 2vw !important;
    font-weight: 600;
    line-height: 2vw;
    letter-spacing: 0vw;
    color: #314050;
  }
  .user-role {
    font-size: 2vw !important;
    font-weight: 400;
    line-height: 2vw;
    letter-spacing: 0vw;
    color: #60758d;
  }
  .avatar-name {
    font-size: 2vw !important;
    font-weight: 600;
    line-height: 2vw;
    letter-spacing: 0vw;
    color: #314050;
  }
}

/* CSS para versão Mobile na vertical */
@media (max-width: 600px) and (orientation: portrait) {
  .list-item {
    text-align: left;
    padding: 0.8vh;
    border-radius: 4vh;
    overflow: hidden;
  }
  .list-item-active {
    text-align: left;
    padding: 0.8vh;
    border-radius: 4vh;
    border: 0.1vh solid #e8e9e9;
    overflow: hidden;
  }
  .list-item-text {
    font-weight: 700;
  }
  .list-item-text {
    margin: 0vh 0vh 0vh 3vh;
    text-align: left;
    font-size: 2vh !important;
    font-weight: 500;
    line-height: 2vh;
    letter-spacing: 0vh;
    color: #314050;
  }
  .logout-item {
    margin: 1vh 0vh 1vh 0vh !important;
    text-align: left;
  }
  .user-name {
    font-size: 2vh !important;
    font-weight: 600;
    line-height: 2vh;
    letter-spacing: 0vh;
    color: #314050;
  }
  .user-role {
    font-size: 2vh !important;
    font-weight: 400;
    line-height: 2vh;
    letter-spacing: 0vh;
    color: #60758d;
  }
  .avatar-name {
    font-size: 2vh !important;
    font-weight: 600;
    line-height: 2vh;
    letter-spacing: 0vh;
    color: #314050;
  }
}

.list-item:hover {
  background: var(--hover-bg);
}
</style>
<style>
.ripple-effect {
  background-color: v-bind(hoverColor);
  border-radius: 1vw;
  transform: scale(0);
  animation: ripple 600ms linear;
}
@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>
